export const INVOICE_PAYMENT_METHOD_OPTIONS = [
    { value: "pix", label: "PIX" },
    { value: "card", label: "Cartão" },
    { value: "pix_and_card", label: "PIX e Cartão" },
] as const;

export type InvoicePaymentMethodsValue =
    (typeof INVOICE_PAYMENT_METHOD_OPTIONS)[number]["value"];

export const INVOICE_PAYMENT_METHOD_DEFAULT: InvoicePaymentMethodsValue = "pix";

export function getInvoicePaymentMethodLabel(
    value?: string | null
): string {
    if (!value) {
        return "Padrão (herdar)";
    }

    return (
        INVOICE_PAYMENT_METHOD_OPTIONS.find((option) => option.value === value)
            ?.label ?? value
    );
}
